import $ from 'jquery';

export default function() {
  const statusWrapper = document.querySelector('.action-status-messages');

  const removeElementButtons = document.querySelectorAll('.delete_quiz_step');

  const removeHandler = function (e) {
    e.preventDefault();

    const button = e.currentTarget;

    const isNew = button.getAttribute('data-is-new');
    const uuid   = button.getAttribute('data-uuid');
    const contestHashId = button.getAttribute('data-contest-hash-id');

    if (isNew) {
      const item = button.closest('.quiz-step-item');
      item?.remove();

      return;
    }

    $.ajax({
      type: 'POST',
      data: {uuid},
      url: '/cabinet/contests/' + contestHashId + '/quiz-steps/delete',
      success: function (data) {
        if (data.messages) {
          data.messages.forEach(function (message) {
            const statusMsg = document.createElement('div');
            statusMsg.classList.add(['alert']);

            if (data.status == 'ok') {
              statusMsg.classList.add(['alert_success']);
            } else {
              statusMsg.classList.add(['alert_error']);
            }

            statusMsg.innerHTML = message;
            statusWrapper.appendChild(statusMsg);
          });
        }

        if (data.status !== 'ok') {
          return;
        }

        window.location.href = '/cabinet/contests/' + contestHashId + '/custom-fields/settings';
      },
      error: function (data) {
        if (data.messages) {
          data.messages.forEach(function (message) {
            const statusMsg = document.createElement('div');
            statusMsg.classList.add('alert', 'alert_error');

            statusMsg.innerHTML = message;
            statusWrapper.appendChild(statusMsg);
          });
        } else {
          const statusMsg = document.createElement('div');
          statusMsg.classList.add('alert', 'alert_error');
          statusMsg.innerHTML = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  };

  removeElementButtons?.forEach(function (button) {
    button.addEventListener('click', removeHandler);
  });
}